<template>
  <div>
    <el-dialog
      class="process-mind-map-dialog process-mind-map-source-dialog fishbone-form-detail-dialog qc-prd-list-dialog"
      v-dialogDrag
      :visible.sync="innerVisible"
      width="96vw"
      append-to-body
      top="4vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @open="loadData"
      @closed="resetData">
      <div slot="title" class="qc-prd-dialog__title">
        <span>{{ $LANG('', '制程巡检记录') }}</span>
      </div>
      <div class="qc-prd-dialog__body">
        <div class="qc-prd-dialog__toolbar">
          <el-button
            class="qc-prd-dialog__add"
            type="primary"
            size="mini"
            icon="iconfont icon-xinzeng"
            :disabled="addBool"
            @click="addRecord">
            {{ $LANG('0138', '新增') }}
          </el-button>
        </div>
        <el-table
          :data="tableData"
          border
          size="small"
          ref="listTable"
          class="custom-table-border qc-prd-dialog__table"
          v-loading="loading"
          :element-loading-text="$LANG('1959', '加载中')"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 251, 255, 0.8)"
          show-summary
          :summary-method="getSummary"
          :cell-style="{ padding: '2px' }"
          :header-cell-style="headStyle"
          cell-class-name="clearPadding2"
          height="calc(88vh - 97px)"
          highlight-current-row>
          <el-table-column :label="$LANG('0310', '序号')" type="index" width="60" fixed></el-table-column>
          <el-table-column
            v-for="item in visibleColumns"
            :key="item.key"
            :prop="item.key"
            :label="item.title"
            show-overflow-tooltip
            :align="item.align"
            :sortable="item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'"
            :min-width="item.width">
            <template slot-scope="scope">
              <el-checkbox
                v-if="item.edcss === 'checkbox'"
                disabled
                true-label="Y"
                false-label="N"
                v-model="scope.row[item.key]">
              </el-checkbox>
              <el-link v-else-if="item.key === 'IDNO'" :underline="false" @click="openDetail(scope.row, 'view')">
                <span class="qc-prd-dialog__idno">{{ displayText(scope.row[item.key]) }}</span>
              </el-link>
              <el-tag
                v-else-if="isYesNoField(item)"
                size="mini"
                :type="scope.row[item.key] === 'Y' ? 'success' : 'info'"
                effect="dark">
                {{ scope.row[item.key] === 'Y' ? $LANG('2047', '是') : $LANG('2044', '否') }}
              </el-tag>
              <span v-else v-text="displayText(scope.row[item.key])"></span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$LANG('0330', '操作')"
            align="center"
            width="132">
            <template slot-scope="scope">
              <div class="qc-prd-dialog__action-group">
                <el-tooltip :content="$LANG('0139', '查看')" placement="top" effect="light">
                  <el-button
                    class="qc-prd-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-chakan"
                    :aria-label="$LANG('0139', '查看')"
                    @click="openDetail(scope.row, 'view')">
                  </el-button>
                </el-tooltip>
                <template v-if="scope.row.STFG === 'N'">
                  <el-tooltip v-if="!editBool" :content="$LANG('1639', '编辑')" placement="top" effect="light">
                    <el-button
                      class="qc-prd-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-bianji"
                      :aria-label="$LANG('1639', '编辑')"
                      @click="openDetail(scope.row, 'edit')">
                    </el-button>
                  </el-tooltip>
                  <el-button
                    v-else
                    class="qc-prd-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-bianji"
                    disabled
                    :aria-label="$LANG('1639', '编辑')">
                  </el-button>
                  <el-tooltip v-if="!cfmBool" :content="$LANG('0134', '审核')" placement="top" effect="light">
                    <el-button
                      class="qc-prd-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-shenhe"
                      :aria-label="$LANG('0134', '审核')"
                      @click="setStatus(scope.row, 'Y')">
                    </el-button>
                  </el-tooltip>
                  <el-button
                    v-else
                    class="qc-prd-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-shenhe"
                    disabled
                    :aria-label="$LANG('0134', '审核')">
                  </el-button>
                </template>
                <template v-else-if="scope.row.STFG === 'Y'">
                  <el-tooltip v-if="!cfmBool" :content="$LANG('0137', '弃审')" placement="top" effect="light">
                    <el-button
                      class="qc-prd-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-fanshenhe"
                      :aria-label="$LANG('0137', '弃审')"
                      @click="setStatus(scope.row, 'N')">
                    </el-button>
                  </el-tooltip>
                  <el-button
                    v-else
                    class="qc-prd-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-fanshenhe"
                    disabled
                    :aria-label="$LANG('0137', '弃审')">
                  </el-button>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      class="process-mind-map-dialog qc-prd-detail-dialog"
      v-dialogDrag
      :visible.sync="detailVisible"
      :width="dialogWidth"
      append-to-body
      top="4vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="resetDetailData">
      <div slot="title" class="qc-prd-dialog__title">
        <span>{{ detailMode === 'create' ? $LANG('0095', '新增记录') : (detailMode === 'edit' ? $LANG('0921', '编辑记录') : $LANG('0971', '资料明细')) }}</span>
      </div>
      <div class="qc-prd-detail-dialog__body" v-loading="detailLoading">
        <div v-for="(gpitem, gpind) in formGroups" :key="gpind">
          <div class="process-dialog-section qc-prd-detail-dialog__section">
            <span>{{ gpitem.gpnm }}</span>
          </div>
          <Form class="qc-prd-detail-dialog__form" :model="mainRow" :label-width="120" label-position="right" inline>
            <div
              v-for="(item, index) in gpitem.gplist"
              :key="index"
              :class="getMainFormCellClass(item)">
              <FormItem
                v-if="item.fhide === 'N'"
                :class="item.edcss === 'textarea' ? 'qc-prd-detail-dialog__form-item qc-prd-detail-dialog__form-item--wide qc-prd-detail-dialog__form-item--textarea' : 'qc-prd-detail-dialog__form-item'"
                :prop="item.fldno">
                <template slot="label"><span v-if="item.notnull === 'Y'" class="qc-prd-detail-dialog__required">*</span>{{ item.title }}</template>
                <el-date-picker
                  size="medium"
                  :disabled="isMainFieldDisabled(item)"
                  type="date"
                  v-if="item.edcss === 'date'"
                  v-model="mainRow[item.fldno]"
                  clearable
                  value-format="yyyy-MM-dd"
                  style="width:100%">
                </el-date-picker>
                <el-input-number
                  size="medium"
                  :precision="item.dotnum"
                  :disabled="isMainFieldDisabled(item)"
                  v-else-if="item.edcss === 'number'"
                  v-model="mainRow[item.fldno]"
                  style="width:100%">
                </el-input-number>
                <el-checkbox
                  size="medium"
                  border
                  :disabled="isMainFieldDisabled(item)"
                  v-else-if="item.edcss === 'checkbox'"
                  true-label="Y"
                  false-label="N"
                  v-model="mainRow[item.fldno]"
                  style="width:100%">
                </el-checkbox>
                <el-select
                  size="medium"
                  :disabled="isMainFieldDisabled(item)"
                  filterable
                  v-else-if="item.edcss === 'select'"
                  v-model="mainRow[item.fldno]"
                  style="width:100%">
                  <el-option
                    v-for="(option, optIndex) in comboArr[item.fldno] || []"
                    :key="optIndex"
                    :label="option.CNAME"
                    :value="option.CODE">
                  </el-option>
                </el-select>
                <el-input
                  size="medium"
                  :disabled="isMainFieldDisabled(item)"
                  v-else-if="item.edcss === 'button'"
                  v-model="mainRow[item.fldno]"
                  @focus="inputBtn(null, null, item.key)"
                  style="width:100%">
                </el-input>
                <el-input
                  size="medium"
                  :disabled="isMainFieldDisabled(item)"
                  v-else-if="item.edcss === 'textarea'"
                  resize="none"
                  type="textarea"
                  :rows="4"
                  v-model="mainRow[item.fldno]">
                </el-input>
                <el-input
                  size="medium"
                  :placeholder="item.holder"
                  :disabled="isMainFieldDisabled(item)"
                  v-else
                  v-model="mainRow[item.fldno]">
                </el-input>
              </FormItem>
            </div>
          </Form>
        </div>
        <div class="process-dialog-section qc-prd-detail-dialog__section qc-prd-detail-dialog__section--detail">
          <span>{{ $LANG('0109', '明细资料') }}</span>
          <el-button
            class="qc-prd-detail-dialog__detail-add"
            type="primary"
            size="mini"
            icon="iconfont icon-xinzeng"
            :disabled="addBool || saveFlag"
            @click="addDetailRow">
            {{ $LANG('0087', '新增明细') }}
          </el-button>
        </div>
        <el-table
          :data="detailData"
          border
          size="small"
          ref="detailTable"
          class="custom-table-border qc-prd-detail-dialog__table"
          show-summary
          :summary-method="getSummary"
          :cell-style="{ padding: '2px', 'font-size': '12px' }"
          cell-class-name="clearPadding2"
          height="34vh"
          highlight-current-row
          @row-click="rowClick">
          <el-table-column :label="$LANG('0310', '序号')" type="index" width="60" fixed></el-table-column>
          <el-table-column
            v-for="item in visibleDetailColumns"
            :key="item.key"
            :prop="item.key"
            :label="item.title"
            show-overflow-tooltip
            :align="item.align"
            :sortable="item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'"
            :min-width="item.width">
            <template slot="header">{{ item.title }}<span v-if="item.notnull === 'Y'" class="qc-prd-detail-dialog__required">*</span></template>
            <template slot-scope="scope">
              <span v-if="saveFlag">
                <el-checkbox
                  v-if="item.edcss === 'checkbox'"
                  disabled
                  true-label="Y"
                  false-label="N"
                  v-model="scope.row[item.key]">
                </el-checkbox>
                <span v-else-if="item.key === 'DEPTNO'" v-text="displayText(scope.row.DEPTNM)"></span>
                <span v-else v-text="displayText(scope.row[item.key])"></span>
              </span>
              <span v-else>
                <el-select
                  v-if="item.key === 'DEPTNO'"
                  size="mini"
                  filterable
                  v-model="scope.row[item.key]"
                  @change="deptChg(scope.row)">
                  <el-option
                    v-for="(option, optIndex) in deptArr"
                    :key="optIndex"
                    :label="option.CNAME"
                    :value="option.CODE">
                  </el-option>
                </el-select>
                <el-input
                  v-else-if="item.edcss === 'button'"
                  size="mini"
                  v-model="scope.row[item.key]"
                  @focus="inputBtn(scope.row, scope.$index, item.key)"
                  style="width:100%">
                </el-input>
                <el-input
                  v-else-if="item.disabled === 'N' && item.edcss === 'number'"
                  type="number"
                  size="mini"
                  v-model="scope.row[item.key]"
                  @input="qtyPrc(scope.row)"
                  @keydown.native="handleNumberKeydown"
                  style="width:100%">
                </el-input>
                <el-date-picker
                  v-else-if="item.edcss === 'date'"
                  :disabled="item.disabled !== 'N'"
                  type="date"
                  size="mini"
                  v-model="scope.row[item.key]"
                  :clearable="false"
                  value-format="yyyy-MM-dd"
                  style="width:100%">
                </el-date-picker>
                <el-checkbox
                  v-else-if="item.edcss === 'checkbox'"
                  :disabled="item.disabled !== 'N'"
                  true-label="Y"
                  false-label="N"
                  size="mini"
                  v-model="scope.row[item.key]"
                  style="width:100%">
                </el-checkbox>
                <el-input
                  v-else-if="item.disabled === 'N'"
                  size="mini"
                  v-model="scope.row[item.key]"
                  style="width:100%">
                </el-input>
                <span v-else v-text="displayText(scope.row[item.key])"></span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$LANG('0330', '操作')"
            align="center"
            width="70">
            <template slot-scope="scope">
              <el-button
                class="qc-prd-dialog__detail-delete"
                type="text"
                size="mini"
                icon="iconfont icon-shanchu1"
                :disabled="saveFlag"
                @click="deleteDetailRow(scope.row, scope.$index)">
                {{ $LANG('0131', '删除') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="qc-prd-dialog__footer">
        <span class="qc-prd-detail-dialog__status">
          <i v-if="mainRow.STFG === 'N'" class="iconfont icon-weishenhe3"></i>
          <i v-else-if="mainRow.STFG === 'Y'" class="iconfont icon-yishenhe1"></i>
          <i v-else-if="mainRow.STFG === 'X'" class="iconfont icon-yizuofei"></i>
        </span>
        <el-button type="info" size="small" icon="iconfont icon-shanchu" @click="detailVisible = false">{{ $LANG('0132', '取消') }}</el-button>
        <el-button
          type="primary"
          size="small"
          icon="iconfont icon-baocun"
          :disabled="saveFlag || saving || (detailMode === 'create' ? addBool : editBool)"
          @click="saveDetail">
          {{ $LANG('0130', '保存') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="process-mind-map-dialog qc-prd-select-dialog"
      v-dialogDrag
      :visible.sync="selectVisible"
      :width="dialogWidth"
      append-to-body
      top="4vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div slot="title" class="qc-prd-dialog__title">
        <span>{{ $LANG('0997', '选择记录') }}</span>
      </div>
      <div class="qc-prd-select-dialog__body">
        <div class="qc-prd-select-dialog__toolbar">
          <span class="qc-prd-select-dialog__label">{{ $LANG('0681', '字段查询') }}</span>
          <el-select
            v-model="selectParam"
            :placeholder="$LANG('1675', '请选择列名')"
            filterable
            size="small"
            class="qc-prd-select-dialog__field">
            <el-option
              v-for="item in selectVisibleColumns"
              :key="item.key"
              :label="item.title"
              :value="item.key">
            </el-option>
          </el-select>
          <el-select v-model="selectOper" size="small" class="qc-prd-select-dialog__oper">
            <el-option
              v-for="item in operArr"
              :key="item.IDSEQ"
              :label="item.CNAME"
              :value="item.SUBNO">
            </el-option>
          </el-select>
          <el-input
            :placeholder="$LANG('1692', '请输入查询值')"
            clearable
            ref="selectQueryInput"
            v-model="selectText"
            @keyup.enter.native="querySelectRows"
            size="small"
            class="qc-prd-select-dialog__input">
            <el-button size="small" slot="append" icon="el-icon-search" @click="querySelectRows"></el-button>
          </el-input>
          <div class="qc-prd-select-dialog__actions">
            <el-button type="primary" size="small" icon="iconfont icon-yiqueren-xianxing" @click="confirmSelectRow">{{ $LANG('1638', '确定') }}</el-button>
            <el-button type="info" size="small" icon="iconfont icon-shanchu" @click="selectVisible = false">{{ $LANG('0132', '取消') }}</el-button>
          </div>
        </div>
        <el-table
          :data="selectPageRows"
          border
          size="small"
          ref="selectTableRef"
          header-cell-class-name="clearPadding"
          :header-cell-style="{ color: '#389', 'text-align': 'center' }"
          class="custom-table-border qc-prd-select-dialog__table"
          :cell-style="{ padding: '2px', color: 'black', 'font-size': '12px' }"
          v-loading="selectLoading"
          :element-loading-text="$LANG('1959', '加载中')"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 251, 255, 0.8)"
          height="68vh"
          @row-click="selectRowClick"
          @row-dblclick="confirmSelectRow"
          highlight-current-row>
          <el-table-column :label="$LANG('0310', '序号')" type="index" width="60" fixed></el-table-column>
          <el-table-column
            v-for="item in selectVisibleColumns"
            :key="item.key"
            :prop="item.key"
            :label="item.title"
            show-overflow-tooltip
            :align="item.align"
            :sortable="item.edcss !== 'checkbox' && item.sortable === 'N'"
            :min-width="item.width">
            <template slot-scope="scope">
              <el-checkbox
                v-if="item.edcss === 'checkbox'"
                disabled
                true-label="Y"
                false-label="N"
                v-model="scope.row[item.key]">
              </el-checkbox>
              <span v-else v-text="displayText(scope.row[item.key])"></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="qc-prd-select-dialog__pager">
          <Page :total="selectDataCount" :page-size="selectRowSize" show-total :current="selectCurrent" @on-change="changeSelectPage"></Page>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBaseData, getTabColOrData } from '../../api/user'
import { getDate } from '../../api/Select'

export default {
  name: 'QcPrdDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    node: {
      type: Object,
      default: function () { return null }
    }
  },
  data: function () {
    return {
      loading: false,
      detailLoading: false,
      saving: false,
      detailVisible: false,
      detailMode: 'view',
      saveFlag: true,
      columns: [],
      tableData: [],
      formGroups: [],
      detailColumns: [],
      requiredFields: [],
      comboArr: {},
      mainRow: {},
      detailData: [],
      delDtlArr: [],
      deptArr: [],
      taskColumns: [],
      hrColumns: [],
      selectVisible: false,
      selectColumns: [],
      selectTable: '',
      selectKey2: '',
      selectValue2: '',
      selectRow: null,
      selectIndex: -1,
      selectKey: '',
      selectParam: '',
      selectText: '',
      selectOper: 'like',
      selectLoading: false,
      selectSelectedRow: {},
      selectRows: [],
      selectPageRows: [],
      selectDataCount: 0,
      selectCurrent: 1,
      selectRowSize: 50,
      operArr: [],
      currentDetailIndex: 0,
      addBool: false,
      editBool: false,
      cfmBool: false
    }
  },
  computed: {
    innerVisible: {
      get: function () { return this.visible },
      set: function (value) { this.$emit('update:visible', value) }
    },
    dialogWidth: function () {
      return (window.innerWidth - 140) + 'px'
    },
    visibleColumns: function () {
      return this.columns.filter(function (item) { return item.thide === 'N' })
    },
    visibleDetailColumns: function () {
      return this.detailColumns.filter(function (item) { return item.thide === 'N' })
    },
    selectVisibleColumns: function () {
      return this.selectColumns.filter(function (item) { return item.thide === 'N' && item.key !== 'SEL' })
    },
    vUsername: function () {
      return this.$cookies.get('v_telno')
    },
 
    vUsernm: function () {
      return this.$cookies.get('v_usernm')
    },
    vAdmin: function () {
      return this.$cookies.get('v_admin')
    },
    vCorpid: function () {
      return (this.getNodeData() && this.getNodeData().CORPID) || this.$cookies.get('v_corpid')
    },
    tableUrl: function () {
      return  'xuper_auth/getTableRecMany'
    },
    formGroupUrl: function () {
      return  'xuper_auth/getFormGroup'
    },
    noauthUrl: function () {
      return  'xuper_auth/getBaseData'
    }
  },
  methods: {
    getMainFormCellClass: function (item) {
      var classes = ['qc-prd-detail-dialog__form-cell']
      if (item && item.edcss === 'textarea') classes.push('qc-prd-detail-dialog__form-cell--wide')
      if (this.isMainFieldDisabled(item)) classes.push('qc-prd-detail-dialog__form-cell--disabled')
      return classes
    },
    resetData: function () {
      this.loading = false
      this.columns = []
      this.tableData = []
      this.detailVisible = false
      this.selectVisible = false
      this.resetDetailData()
    },
    resetDetailData: function () {
      this.detailLoading = false
      this.saving = false
      this.detailMode = 'view'
      this.saveFlag = true
      this.formGroups = []
      this.detailColumns = []
      this.requiredFields = []
      this.comboArr = {}
      this.mainRow = {}
      this.detailData = []
      this.delDtlArr = []
      this.currentDetailIndex = 0
      this.selectColumns = []
      this.selectTable = ''
      this.selectKey2 = ''
      this.selectValue2 = ''
      this.selectRow = null
      this.selectIndex = -1
      this.selectKey = ''
      this.resetSelectData()
    },
    loadData: function () {
      this.loading = true
      Promise.all([
        this.loadListColumns(),
        this.loadRows(),
        this.loadPermission(),
        this.loadRequiredFields(),
        this.loadDeptRows(),
        this.loadTaskColumns(),
        this.loadHrColumns(),
        this.loadOperRows()
      ]).then(function (result) {
        this.columns = result[0] || []
        this.tableData = result[1] || []
        this.requiredFields = result[3] || []
        this.deptArr = result[4] || []
        this.taskColumns = result[5] || []
        this.hrColumns = result[6] || []
        this.operArr = result[7] || []
        this.$nextTick(function () {
          if (this.$refs.listTable && this.$refs.listTable.doLayout) this.$refs.listTable.doLayout()
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
      this.loading = false
    }.bind(this))
    },
    normalizeResultRows: function (res, silent) {
      var result = res && res && res.result
      if (Array.isArray(result)) return result
      if (result && !silent) this.$emit('error', String(result).split('\n')[0] || this.$LANG('1442', '提示'))
      return []
    },
    reloadAfterChange: function () {
      return this.loadRows().then(function (rows) {
        this.tableData = rows || []
        this.$emit('changed')
        this.$nextTick(function () {
          if (this.$refs.listTable && this.$refs.listTable.doLayout) this.$refs.listTable.doLayout()
        })
      }.bind(this))
    },
    loadPermission: function () {
      this.addBool = false
      this.editBool = false
      this.cfmBool = false
      return getTabColOrData(this.tableUrl,  'v_sys_user_priv', 'userno', this.vUsername, 'frmidseq', '412735', '', '', '').then(function (res) {
        if (this.vAdmin !== 'N') return
        var rows = this.normalizeResultRows(res, true)
        var row = rows[0] || {}
        this.addBool = row.ISADD === 'N'
        this.editBool = row.ISUPD === 'N'
        this.cfmBool = row.ISCFM === 'N'
      }.bind(this))
    },
    loadRequiredFields: function () {
      return getTabColOrData(this.tableUrl,   'v_sys_form_fld', 'idseq', '412735', 'LSTSEQ', '1', 'NOTNULL', 'Y', '').then(function (res) {
        return this.normalizeResultRows(res, true).map(function (item) {
          return this.normalizeColumn(item)
        }.bind(this))
      }.bind(this))
    },
    loadListColumns: function () {
      return this.loadColumns('1')
    },
    loadDetailColumns: function () {
      return this.loadColumns('2')
    },
    loadTaskColumns: function () {
      return this.loadColumnsByForm('412735', '3')
    },
    loadHrColumns: function () {
      return this.loadColumnsByForm('4204', '1')
    },
    loadColumns: function (lstseq, orderBy) {
      return this.loadColumnsByForm('412735', lstseq, orderBy)
    },
    loadColumnsByForm: function (formId, lstseq, orderBy) {
      return getTabColOrData(this.tableUrl,  'v_sys_form_fld', 'idseq', formId, 'lstseq', lstseq, '', '', orderBy || ' order by sortby,lstseq').then(function (res) {
        var list = this.normalizeResultRows(res, true)
        return list.map(function (item) {
          return this.normalizeColumn(item)
        }.bind(this))
      }.bind(this))
    },
    normalizeColumn: function (item) {
      return {
        title: this.$translate.getColTitle(item, this.$store.state.lang),
        key: item.key || item.FLDNO,
        fldno: item.FLDNO || item.key,
        align: item.align,
        width: item.width,
        thide: item.THIDE,
        fhide: item.FHIDE,
        edcss: item.EDCSS,
        disabled: item.DISABLED,
        dotnum: item.DOTNUM,
        sortable: item.SORTABLE,
        notnull: item.NOTNULL,
        combo: item.COMBO,
        holder: item.HOLDER
      }
    },
    loadRows: function () {
      var payload
      try {
        payload = this.getDynamicPayload()
      } catch (error) {
        return Promise.resolve([])
      }
      return getTabColOrData(
        this.tableUrl,
  
        payload.p_table,
        payload.p_key,
        payload.p_value,
        payload.p_key2,
        payload.p_value2,
        payload.p_key3,
        payload.p_value3,
        payload.p_cond
      ).then(function (res) {
        return this.normalizeResultRows(res)
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
        return []
      }.bind(this))
    },
    loadDeptRows: function () {
      return getBaseData(this.tableUrl + '', 'CORPID', this.vCorpid, '', '', 'v_HR_DEPT', '').then(function (res) {
        return this.normalizeResultRows(res, true)
      }.bind(this))
    },
    loadOperRows: function () {
      return getBaseData(this.noauthUrl, 'PARENTNO', '15995', '', '', 'v_sys_base', '').then(function (res) {
        return this.normalizeResultRows(res, true)
      }.bind(this))
    },
    getNodeData: function () {
      return (this.node && this.node.nodeData) || {}
    },
    getRequiredSourceParams: function () {
      var row = this.getNodeData()
      var params = {
        ORDNO: row.ORDNO || row.IDNO || row.REFIDNO,
        MATNO: row.MATNO,
        CORPID: row.CORPID || this.$cookies.get('v_corpid')
      }
      var missing = []
      Object.keys(params).forEach(function (key) {
        if (key === 'MATNO') return
        if (params[key] === undefined || params[key] === null || params[key] === '') missing.push(key)
      })
      if (missing.length) throw new Error('MISSING_SOURCE_PARAMS')
      return params
    },
    escapeQueryValue: function (value) {
      return String(value === undefined || value === null ? '' : value).trim().replace(/'/g, "''")
    },
    getDynamicPayload: function () {
      var params = this.getRequiredSourceParams()
      return {
        p_key: '',
        p_value: '',
        p_key2: 'CORPID',
        p_value2: params.CORPID,
        p_key3: '',
        p_value3: '',
        p_table: 'V_QC_CHK',
        p_cond: " and IDNO like '%%' and ORDNO like '%" + this.escapeQueryValue(params.ORDNO) + "%' order by IDNO desc"
      }
    },
    addRecord: function () {
      if (this.addBool) return
      this.detailVisible = true
      this.detailLoading = true
      this.detailMode = 'create'
      this.saveFlag = false
      this.mainRow = {
        DTTM: getDate('day'),
        IDSEQ: '',
        STFG: 'N',
        ISGIVE: 'Y',
        CORPID: this.vCorpid
      }
      this.detailData = []
      this.delDtlArr = []
      Promise.all([
        this.loadFormGroups(),
        this.loadDetailColumns(),
        this.loadFormCombos()
      ]).then(function (result) {
        this.formGroups = result[0] || []
        this.detailColumns = result[1] || []
        this.comboArr = result[2] || {}
        this.$nextTick(function () {
          if (this.$refs.detailTable && this.$refs.detailTable.doLayout) this.$refs.detailTable.doLayout()
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.detailLoading = false
      }.bind(this))
    },
    openDetail: function (row, mode) {
      if (!row) return
      if (mode === 'edit' && this.editBool) return
      this.detailVisible = true
      this.detailLoading = true
      this.detailMode = mode === 'edit' ? 'edit' : 'view'
      this.saveFlag = this.detailMode !== 'edit' || row.STFG === 'Y'
      this.mainRow = JSON.parse(JSON.stringify(Object.assign({}, row, { IDSEQ: row.IDSEQ })))
      this.delDtlArr = []
      Promise.all([
        this.loadFormGroups(),
        this.loadDetailColumns(),
        this.loadFormCombos(),
        this.loadDetailRows(row.IDSEQ)
      ]).then(function (result) {
        this.formGroups = result[0] || []
        this.detailColumns = result[1] || []
        this.comboArr = result[2] || {}
        this.detailData = result[3] || []
        this.$nextTick(function () {
          if (this.$refs.detailTable && this.$refs.detailTable.doLayout) this.$refs.detailTable.doLayout()
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.detailLoading = false
      }.bind(this))
    },
    loadFormGroups: function () {
      return getTabColOrData(this.formGroupUrl, 'v_sys_form_fld', 'idseq', '412735', 'gpnm,gpsort', '', 'lstseq', '1', ' order by gpsort').then(function (res) {
        var groups = this.normalizeResultRows(res, true)
        return groups.map(function (group) {
          var nextGroup = Object.assign({}, group)
          nextGroup.gplist = (group.gplist || []).map(function (item) {
            return this.normalizeColumn(item)
          }.bind(this)).filter(function (item) {
            return item && item.fhide === 'N'
          })
          return nextGroup
        }.bind(this)).filter(function (group) {
          return group.gplist && group.gplist.length
        })
      }.bind(this))
    },
    loadFormCombos: function () {
      return getTabColOrData(this.tableUrl,  'v_sys_form_fld', 'idseq', '412735', 'edcss', 'select', '', '', ' and lstseq in (1,2)').then(function (res) {
        var fields = this.normalizeResultRows(res, true)
        return Promise.all(fields.map(function (field) {
          return this.loadComboOptions(field)
        }.bind(this))).then(function (results) {
          var comboMap = {}
          results.forEach(function (item) {
            if (item.fldno) comboMap[item.fldno] = item.options
            if (item.key) comboMap[item.key] = item.options
          })
          return comboMap
        })
      }.bind(this))
    },
    loadComboOptions: function (field) {
      if (!field || !field.COMBO) return Promise.resolve({ fldno: field && field.FLDNO, key: field && field.key, options: [] })
      return getTabColOrData(this.noauthUrl,  'v_sys_base', 'parentno', field.COMBO, '', '', '', '', '').then(function (res) {
        return {
          fldno: field.FLDNO,
          key: field.key,
          options: this.normalizeResultRows(res, true)
        }
      }.bind(this))
    },
    loadDetailRows: function (idseq) {
      if (!idseq) return Promise.resolve([])
      return getTabColOrData(this.tableUrl,  'V_qc_chkdtl', 'idseq', idseq, '', '', '', '', ' ORDER BY lstseq').then(function (res) {
        return this.normalizeResultRows(res)
      }.bind(this))
    },
    isMainFieldDisabled: function (item) {
      return this.saveFlag || (item && item.disabled === 'Y')
    },
    addDetailRow: function () {
      if (this.addBool || this.saveFlag) return
      var row = {}
      this.detailColumns.forEach(function (item) {
        row[item.key] = ''
      })
      row.ISCHK = 'Y'
      this.detailData.push(row)
      this.delDtlArr = []
      this.$nextTick(function () {
        if (this.$refs.detailTable && this.$refs.detailTable.doLayout) this.$refs.detailTable.doLayout()
      })
    },
    deleteDetailRow: function (row, index) {
      if (this.saveFlag) return
      if (row && row.LSTSEQ) this.delDtlArr.push(row)
      this.detailData.splice(index, 1)
    },
    validateDetail: function () {
      var missingTitle = ''
      this.requiredFields.some(function (item) {
        if (!this.mainRow[item.fldno]) {
          missingTitle = item.title
          return true
        }
        return false
      }.bind(this))
      if (missingTitle) {
        this.$emit('error', missingTitle + this.$LANG('2051', '不能为空'))
        return false
      }
      if (!this.detailData.length) {
        this.$emit('error', this.$LANG('0109', '明细资料') + this.$LANG('2051', '不能为空'))
        return false
      }
      this.detailData.some(function (row) {
        return this.detailColumns.filter(function (item) { return item.notnull === 'Y' }).some(function (item) {
          if (!row[item.key]) {
            missingTitle = item.title
            return true
          }
          return false
        })
      }.bind(this))
      if (missingTitle) {
        this.$emit('error', missingTitle + this.$LANG('2051', '不能为空'))
        return false
      }
      return true
    },
    saveDetail: function () {
      if (this.saveFlag || this.saving) return
      if (this.detailMode === 'create' && this.addBool) return
      if (this.detailMode === 'edit' && this.editBool) return
      if (!this.validateDetail()) return
      this.saving = true
      this.$axios({
        method: 'post',
        url:  'xuper_auth/formOneSave',
        data: { p_json: JSON.stringify(Object.assign({}, this.mainRow, { CORPID: this.vCorpid })), p_table: 'QC_CHK', frmid: '412735' }
      }).then(function (res) {
        if (res && res.result === 'OK') {
          var idseq = res.idseq
          return this.$axios({
            method: 'post',
            url:  'xuper_auth/batDtlSave2',
            data: { p_json: JSON.stringify(this.detailData), p_table: 'QC_CHKDTL', p_idseq: idseq, p_action: 'S' }
          }).then(function () {
            return this.deleteRemovedDetailRows(idseq).then(function () {
              this.detailVisible = false
              return this.reloadAfterChange()
            }.bind(this))
          }.bind(this))
        }
        this.$emit('error', (res && res.result) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.saving = false
      }.bind(this))
    },
    deleteRemovedDetailRows: function (idseq) {
      var promise = Promise.resolve()
      this.delDtlArr.forEach(function (row) {
        promise = promise.then(function () {
          return this.$axios({
            method: 'post',
            url:  'xuper_auth/delTabRec',
            data: { p_key: 'idseq', p_value: idseq, p_key2: 'lstseq', p_value2: row.LSTSEQ, p_table: 'QC_CHKdtl', p_action: 'D' }
          })
        }.bind(this))
      }.bind(this))
      return promise
    },
    setStatus: function (row, value) {
      if (!row) return
      if (this.cfmBool) return
      var statusText = value === 'Y' ? this.$LANG('0134', '审核') : this.$LANG('0137', '弃审')
      this.$confirm(this.$LANG('1564', '你确定要') + statusText + this.$LANG('1565', '此单据吗?'), this.$LANG('1442', '提示'), {
        confirmButtonText: this.$LANG('1638', '确定'),
        cancelButtonText: this.$LANG('0132', '取消'),
        customClass: 'process-mind-map-message-box',
        showClose: false,
        type: 'info'
      }).then(function () {
        var cond = ''
        if (value === 'Y') {
          cond = " set stfg='Y',chkuser='" + this.escapeQueryValue(this.vUsernm) + "',chkdttm='" + getDate('full') + "'"
        } else {
          cond = " set stfg='N',chkuser='',chkdttm='',appuser='',appdttm=''"
        }
        return this.$axios({
          method: 'post',
          url:  'xuper_auth/updateRec',
          data: { p_key: 'idseq', p_value: row.IDSEQ, p_table: 'QC_CHK', p_cond: cond }
        }).then(function (res) {
          if (res && res.code === '200') return this.reloadAfterChange()
          this.$emit('error', (res && (res.message || res.result)) || this.$LANG('1442', '提示'))
        }.bind(this))
      }.bind(this)).catch(function () {})
    },
    qtyPrc: function (row) {
      if (!row) return
      row.BADQTY = Number(row.SZQTY || 0) + Number(row.LOOKQTY || 0) + Number(row.OTHQTY || 0)
    },
    deptChg: function (row) {
      if (!row) return
      row.EMPNO = ''
      row.EMPNM = ''
    },
    rowClick: function (row) {
      this.currentDetailIndex = row && row.index !== undefined ? row.index : this.detailData.indexOf(row)
    },
    inputBtn: function (row, index, key) {
      this.selectKey = key
      this.selectRow = row
      this.selectIndex = index === null || index === undefined ? -1 : index
      this.resetSelectData()
      if (key === 'EMPNO') {
        this.selectColumns = this.hrColumns
        this.selectTable = 'v_HR_EMP'
        this.selectKey2 = 'DEPTNO'
        this.selectValue2 = row ? row.DEPTNO : ''
        this.selectVisible = true
        this.$nextTick(function () {
          this.initSelectParam()
          this.querySelectRows()
        })
      } else if (key === 'TASKNO') {
        this.selectColumns = this.taskColumns
        this.selectTable = 'v_pc_taskDTL'
        this.selectKey2 = ''
        this.selectValue2 = ''
        this.selectVisible = true
        this.$nextTick(function () {
          this.initSelectParam()
          this.querySelectRows()
        })
      }
    },
    resetSelectData: function () {
      this.selectParam = ''
      this.selectText = ''
      this.selectOper = 'like'
      this.selectLoading = false
      this.selectSelectedRow = {}
      this.selectRows = []
      this.selectPageRows = []
      this.selectDataCount = 0
      this.selectCurrent = 1
    },
    initSelectParam: function () {
      var firstIdColumn = this.selectVisibleColumns.filter(function (item) { return item.key === 'ORDNO' || item.key === 'IDNO' })[0]
      this.selectParam = firstIdColumn ? firstIdColumn.key : ((this.selectVisibleColumns[0] && this.selectVisibleColumns[0].key) || '')
      if (this.$refs.selectQueryInput && this.$refs.selectQueryInput.focus) this.$refs.selectQueryInput.focus()
    },
    querySelectRows: function () {
      if (!this.selectTable) return
      this.selectLoading = true
      var cond = ''
      if (this.selectParam && this.selectText) {
        if (this.selectOper === 'like') {
          cond += " and upper(" + this.selectParam + ") like upper('%" + this.escapeQueryValue(this.selectText) + "%')"
        } else {
          cond += " and upper(" + this.selectParam + ')' + this.selectOper + "upper('" + this.escapeQueryValue(this.selectText) + "')"
        }
      }
      this.$axios({
        method: 'post',
        url:  'xuper_auth/getBaseData',
        data: {
          p_key: 'corpid',
          p_value: this.vCorpid,
          p_key2: this.selectKey2,
          p_value2: this.selectValue2,
          p_cond: cond,
          p_table: this.selectTable
        }
      }).then(function (res) {
        this.selectRows = this.normalizeResultRows(res)
        this.selectSelectedRow = {}
        this.initSelectPage()
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
        this.selectRows = []
        this.initSelectPage()
      }.bind(this)).finally(function () {
        this.selectLoading = false
        this.$nextTick(function () {
          if (this.$refs.selectTableRef && this.$refs.selectTableRef.doLayout) this.$refs.selectTableRef.doLayout()
        })
      }.bind(this))
    },
    initSelectPage: function () {
      this.selectDataCount = this.selectRows.length
      this.selectCurrent = 1
      this.changeSelectPage(1)
    },
    changeSelectPage: function (page) {
      var start = (page - 1) * this.selectRowSize
      var end = page * this.selectRowSize
      this.selectCurrent = page
      this.selectPageRows = this.selectRows.slice(start, end)
    },
    selectRowClick: function (row) {
      this.selectSelectedRow = JSON.parse(JSON.stringify(row || {}))
    },
    confirmSelectRow: function () {
      if (this.selectSelectedRow && this.selectSelectedRow.IDSEQ) {
        this.handleSelectSure(this.selectSelectedRow)
      } else {
        this.$emit('error', this.$LANG('1695', '请选择一记录'))
      }
    },
    handleSelectSure: function (obj) {
      if (this.selectKey === 'TASKNO' && this.selectRow) {
        Object.assign(this.selectRow, {
          TASKNO: obj.IDNO,
          PRDNM: obj.MATNM,
          WKNM: obj.WKNM,
          PRDQTY: obj.QTY,
          JOBNM: obj.CJOBNM,
          REFIDSEQ: obj.IDSEQ,
          REFLSTSEQ: obj.LSTSEQ
        })
        if (this.selectIndex > -1) this.detailData.splice(this.selectIndex, 1, Object.assign({}, this.selectRow))
      } else if (this.selectKey === 'EMPNO' && this.selectRow) {
        Object.assign(this.selectRow, {
          EMPNO: obj.IDNO,
          EMPNM: obj.EMPNM
        })
        if (this.selectIndex > -1) this.detailData.splice(this.selectIndex, 1, Object.assign({}, this.selectRow))
      } else if (this.selectKey === 'EMPNO') {
        Object.assign(this.mainRow, {
          EMPNO: obj.IDNO,
          EMPNM: obj.EMPNM
        })
      } else if (this.selectKey !== 'TASKNO') {
        Object.assign(this.mainRow, {
          RFILENM: obj.FILENM,
          RFILENO: obj.FNO,
          VER: obj.VER,
          REFIDSEQ: obj.IDSEQ,
          REFLSTSEQ: obj.LSTSEQ
        })
      }
      this.selectVisible = false
    },
    handleNumberKeydown: function (event) {
      if (['e', 'E', '+'].indexOf(event.key) > -1) event.returnValue = false
    },
    isYesNoField: function (item) {
      return item && (item.edcss === 'checkbox' || item.key === 'STFG' || item.key === 'ISGIVE' || item.key === 'ISCHK')
    },
    displayText: function (value) {
      return value === undefined || value === null || value === '' ? '-' : value
    },
    headStyle: function (params) {
      var column = params.column || {}
      if (this.getSummaryFields().indexOf(column.property) > -1) return 'color:red'
    },
    getSummaryFields: function () {
      return ['QTY', 'PRDQTY', 'CHKQTY', 'BADQTY', 'OKQTY', 'QUALQTY', 'NOQTY', 'SZQTY', 'LOOKQTY', 'OTHQTY']
    },
    getSummary: function (param) {
      var sums = []
      var sumFields = this.getSummaryFields()
      param.columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = this.$LANG('0280', '合计')
          return
        }
        if (sumFields.indexOf(column.property) === -1) return
        var values = param.data.map(function (item) { return Number(item[column.property]) })
        var sumValue = values.reduce(function (prev, curr) {
          if (!isNaN(curr)) return Number(prev) + Number(curr)
          return prev
        }, 0)
        sums[index] = sumValue ? sumValue.toFixed(2) : ''
      }.bind(this))
      return sums
    }
  }
}
</script>

<style scoped lang="less">
.qc-prd-dialog__title {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 56px 0 20px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
  color: #1f2f3d;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}
.qc-prd-dialog__body {
  min-height: 70vh;
}
.qc-prd-dialog__toolbar {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 8px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
}
.qc-prd-dialog__add {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 26px !important;
  min-height: 26px !important;
  padding: 0 10px !important;
  border-radius: 13px !important;
  font-size: 12px !important;
  line-height: 26px !important;
}
.qc-prd-dialog__add i {
  margin-right: 4px !important;
  font-size: 14px !important;
  line-height: 14px !important;
}
.qc-prd-dialog__table,
.qc-prd-detail-dialog__table {
  width: 100%;
}
.qc-prd-dialog__table {
  flex: 1 1 auto;
  min-height: 0;
}
.qc-prd-dialog__idno {
  color: #606266;
  font-size: 13px;
  font-weight: 700;
  border-bottom: 1px solid red;
}
.qc-prd-dialog__action-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.qc-prd-dialog__action-button {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 32px !important;
  min-width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 50% !important;
  color: #409eff;
  line-height: 32px !important;
}
.qc-prd-dialog__action-button i {
  display: inline-block;
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  font-size: 16px !important;
  line-height: 16px !important;
  vertical-align: middle;
}
.qc-prd-dialog__action-button ::v-deep i,
.qc-prd-dialog__action-button ::v-deep [class^="iconfont"],
.qc-prd-dialog__action-button ::v-deep [class*=" iconfont"] {
  display: inline-block;
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  font-size: 16px !important;
  line-height: 16px !important;
}
.qc-prd-dialog__action-button:hover,
.qc-prd-dialog__action-button:focus {
  background: rgba(64, 158, 255, .1);
  color: #1f78ff;
}
.qc-prd-dialog__action-button.is-disabled,
.qc-prd-dialog__action-button.is-disabled:hover,
.qc-prd-dialog__action-button.is-disabled:focus {
  background: transparent;
  color: #c0c4cc;
}
.qc-prd-detail-dialog__body {
  height: 82vh;
  padding: 14px 18px 20px;
  overflow-y: auto;
  background: #fff;
  box-sizing: border-box;
}
.qc-prd-detail-dialog__section {
  margin: 8px 0 !important;
  padding: 0 2px;
}
.qc-prd-detail-dialog__section--detail {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0 !important;
}
.qc-prd-detail-dialog__detail-add {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 26px !important;
  min-height: 26px !important;
  min-width: 78px !important;
  padding: 0 10px !important;
  border-radius: 13px !important;
  font-size: 12px !important;
  line-height: 26px !important;
}
.qc-prd-detail-dialog__detail-add i {
  margin-right: 4px !important;
  font-size: 14px !important;
  line-height: 14px !important;
}
.qc-prd-detail-dialog__form {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 48px;
  row-gap: 16px;
  padding: 0 12px 20px;
  box-sizing: border-box;
}
.qc-prd-detail-dialog__form-item {
  width: 100%;
  min-width: 0;
  margin: 0 !important;
}
.qc-prd-detail-dialog__form-cell {
  min-width: 0;
  min-height: 32px;
}
.qc-prd-detail-dialog__form-cell--wide {
  grid-column: 1 / -1;
}
.qc-prd-detail-dialog__form-item--wide {
  width: 100%;
}
.qc-prd-detail-dialog__table {
  margin-top: 0;
}
.qc-prd-detail-dialog__table .el-table__body-wrapper {
  min-height: 260px;
}
.qc-prd-detail-dialog__required {
  color: red;
}
.qc-prd-dialog__detail-delete {
  color: #409eff;
}
.qc-prd-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
}
.qc-prd-detail-dialog__status {
  min-width: 32px;
  color: red;
  font-size: 28px;
  line-height: 1;
}
.qc-prd-select-dialog__body {
  height: 82vh;
  overflow: hidden;
  background: #fff;
}
.qc-prd-select-dialog__toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 46px;
  padding: 0 10px;
  border-bottom: 2px solid #389;
  box-sizing: border-box;
}
.qc-prd-select-dialog__label {
  flex: 0 0 auto;
  color: #606266;
  font-size: 12px;
  line-height: 32px;
}
.qc-prd-select-dialog__field {
  width: 170px;
}
.qc-prd-select-dialog__oper {
  width: 110px;
}
.qc-prd-select-dialog__input {
  width: 280px;
}
.qc-prd-select-dialog__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 16px;
}
.qc-prd-select-dialog__actions .el-button + .el-button {
  margin-left: 0;
}
.qc-prd-select-dialog__table {
  width: 100%;
}
.qc-prd-select-dialog__pager {
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0 8px;
  background: #fff;
  box-sizing: border-box;
}
@media (max-width: 1200px) {
  .qc-prd-detail-dialog__form {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 24px;
  }
}
</style>

<style lang="less">
.process-mind-map-dialog.qc-prd-list-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 10px;
  }
  .custom-table-border .el-table__body td,
  .custom-table-border .el-table__header th {
    border-color: rgb(184, 181, 181);
    border-width: 1px;
  }
}
.process-mind-map-dialog.qc-prd-detail-dialog,
.process-mind-map-dialog.qc-prd-select-dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;
    border-radius: 8px;
    .el-dialog__body {
      position: absolute;
      left: 0;
      right: 0;
      top: 40px;
      bottom: 0;
      padding: 0;
      overflow: hidden;
    }
  }
  .el-dialog__header {
    padding: 0;
  }
  .custom-table-border .el-table__body td,
  .custom-table-border .el-table__header th {
    border-color: rgb(184, 181, 181);
    border-width: 1px;
  }
}
.process-mind-map-dialog.qc-prd-detail-dialog {
  .el-dialog__body {
    bottom: 54px !important;
  }
  .qc-prd-detail-dialog__form {
    .ivu-form-item {
      margin-bottom: 0 !important;
    }
    .ivu-form-item-label {
      display: inline-flex;
      align-items: center;
      justify-content: flex-end;
      height: 32px;
      width: 120px;
      padding: 0 12px 0 0;
      line-height: 32px;
      text-align: right;
      box-sizing: border-box;
      vertical-align: top;
    }
    .ivu-form-item-content {
      min-height: 32px;
      line-height: 32px;
    }
    .el-input,
    .el-select,
    .el-date-editor,
    .el-input-number {
      height: 32px !important;
      line-height: 32px !important;
    }
    .el-input__inner,
    .el-input--medium .el-input__inner,
    .el-select .el-input__inner,
    .el-date-editor .el-input__inner,
    .el-input-number .el-input__inner {
      height: 32px !important;
      line-height: 32px !important;
    }
    .el-input.is-disabled .el-input__inner,
    .el-textarea.is-disabled .el-textarea__inner,
    .el-input__inner[disabled],
    .el-textarea__inner[disabled] {
      border-color: #dcdfe6 !important;
      background-color: #f5f7fa !important;
      color: #909399 !important;
      cursor: not-allowed !important;
    }
    .el-select .el-input.is-disabled .el-input__inner,
    .el-date-editor.el-input.is-disabled .el-input__inner,
    .el-input-number.is-disabled .el-input__inner {
      border-color: #dcdfe6 !important;
      background-color: #f5f7fa !important;
      color: #909399 !important;
      cursor: not-allowed !important;
    }
    .el-input__icon {
      line-height: 32px !important;
    }
    .el-input-number__decrease,
    .el-input-number__increase {
      width: 32px;
      height: 30px !important;
      line-height: 30px !important;
    }
    .el-input-number .el-input__inner {
      padding-left: 36px;
      padding-right: 36px;
    }
    .qc-prd-detail-dialog__form-cell {
      .el-input.el-input--medium,
      .el-select.el-select--medium,
      .el-date-editor.el-input.el-input--medium,
      .el-input-number.el-input-number--medium {
        height: 32px !important;
        min-height: 32px !important;
        max-height: 32px !important;
        line-height: 32px !important;
        vertical-align: top !important;
      }
      .el-input.el-input--medium .el-input__inner,
      .el-select.el-select--medium .el-input.el-input--medium .el-input__inner,
      .el-date-editor.el-input.el-input--medium .el-input__inner,
      .el-input-number.el-input-number--medium .el-input.el-input--medium .el-input__inner {
        height: 32px !important;
        min-height: 32px !important;
        max-height: 32px !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        line-height: 32px !important;
        box-sizing: border-box !important;
      }
      .el-input-number.el-input-number--medium {
        display: inline-flex !important;
        align-items: center !important;
      }
      .el-input-number.el-input-number--medium .el-input {
        display: block !important;
        height: 32px !important;
        line-height: 32px !important;
      }
      .el-input-number.el-input-number--medium .el-input__inner {
        padding-right: 36px !important;
        padding-left: 36px !important;
        vertical-align: top !important;
      }
      .el-input-number.el-input-number--medium .el-input-number__decrease,
      .el-input-number.el-input-number--medium .el-input-number__increase {
        top: 1px !important;
        width: 32px !important;
        height: 30px !important;
        line-height: 30px !important;
      }
    }
    .el-input-number.is-disabled .el-input-number__decrease,
    .el-input-number.is-disabled .el-input-number__increase {
      border-color: #dcdfe6 !important;
      background-color: #f5f7fa !important;
      color: #c0c4cc !important;
      cursor: not-allowed !important;
    }
    .qc-prd-detail-dialog__form-cell--disabled {
      .el-input__inner,
      .el-textarea__inner,
      .el-input-number__decrease,
      .el-input-number__increase {
        border-color: #dcdfe6 !important;
        background-color: #f5f7fa !important;
        color: #909399 !important;
        cursor: not-allowed !important;
      }
      .el-input,
      .el-select,
      .el-date-editor,
      .el-input-number {
        color: #909399 !important;
      }
      .el-input__prefix,
      .el-input__suffix,
      .el-input__icon,
      .el-select__caret {
        color: #c0c4cc !important;
      }
    }
  }
  .el-dialog__footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 54px;
    padding: 10px 18px;
    border-top: 1px solid #dcdfe6;
    background: #fff;
    box-sizing: border-box;
  }
}
.process-mind-map-dialog.qc-prd-select-dialog {
  .el-dialog__body {
    bottom: 0;
  }
}
</style>
